import React from 'react';
import { ButterBarMenu } from '~/common/components/butter-bar-menu';
import { CallToAction } from '~/common/models';
import { useIsMobile } from '~/common/hooks/use-is-mobile';

interface Props {
  modelName: string;
  hasHybrid: boolean;
  element?: HTMLDivElement | string;
  ctaBuildYourOwn?: CallToAction;
  ctaBookTestDrive?: CallToAction;
  ctaDownloadBrochure?: CallToAction;
  ctaFindDealer?: CallToAction;
  ctaBookService?: CallToAction;
  ctaValueMyCar?: CallToAction;
  ctaShowroom?: CallToAction;
}

export default ({ modelName, hasHybrid, element, ...butterMenu }: Props) => {
  const [butterBarVisible, setButterBarVisible] = React.useState<boolean>(true);
  const lastScrollY = React.useRef<number>(0);
  const h1OffsetTop = React.useRef<number>(0);

  React.useEffect(() => {
    const firstH1 = document.querySelector('h1');
    if (firstH1) {
      h1OffsetTop.current =
        firstH1.getBoundingClientRect().top + window.scrollY;
    } else {
      h1OffsetTop.current = 0;
    }

    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const scrollingDown = currentScrollY > lastScrollY.current;
      const scrollingUp = currentScrollY < lastScrollY.current;

      if (scrollingDown && currentScrollY >= h1OffsetTop.current) {
        setButterBarVisible(false);
      }
      if (scrollingUp) {
        setButterBarVisible(true);
      }
      lastScrollY.current = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div>
      <ButterBarMenu
        modelName={modelName}
        isVisible={butterBarVisible}
        {...butterMenu}
      />
    </div>
  );
};
